import React from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useAuth } from "./useAuth";
import { useRealtimeListRefresh } from "../realtime/RealtimeContext";
import { RealtimeEventTypes } from "../realtime/realtimeEventTypes";
import { createAuthorizationRefresh } from "./authorizationRefresh";

const authorizationEvents = [RealtimeEventTypes.AuthorizationChanged];

export function AuthorizationChangedListener() {
  const auth = useAuth();
  const client = useQueryClient();
  const refresh = React.useRef<ReturnType<typeof createAuthorizationRefresh> | null>(null);
  React.useEffect(() => {
    const current = createAuthorizationRefresh(
      auth.refreshMe,
      () => client.cancelQueries(),
      // Auch Queries ohne Authrevision im Schlüssel dürfen keinen alten Studioscope behalten.
      () => client.resetQueries()
    );
    refresh.current = current;
    return () => { current.dispose(); refresh.current = null; };
  }, [auth.refreshMe, client]);
  const reload = React.useCallback(() => {
    // API-Fehler werden zentral angezeigt; eine widerrufene Sitzung wird von refreshMe abgemeldet.
    void refresh.current?.request().catch(() => {});
  }, []);
  useRealtimeListRefresh({ eventTypes: authorizationEvents, reload, background: false, enabled: !!auth.token });
  return null;
}
